import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel, Collection } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Pipeline } from '../pipeline/pipeline';
import { TriggerProperties } from './trigger-properties';

@Metamodel.model({
    name: 'ChainingTrigger',
    display: [shellStringResources.ModelName_ChainingTrigger, shellStringResources.ModelName_ChainingTriggers]
})
export class ChainingTriggerProperties extends TriggerProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.Trigger_Chaining_DependentPipelines,
        constraint: {
            minOccurs: 1,
            required: true
        },
        collection: Collection.Array,
        reference: true,
        type: Pipeline.MODEL
    })
    public dependsOn: Pipeline[];

    @Metamodel.attribute({
        display: shellStringResources.RunDimensionLabel,
        constraint: {
            required: true
        }
    })
    public runDimension: string;

    public constructor() {
        super();
        this.multiplePipelines = false;
    }
}
